var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "LostModuleDashboard"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Exclude")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exclude),
      expression: "exclude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('exclude')
    },
    attrs: {
      "name": "exclude",
      "id": "exclude"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.exclude = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.excludeList), function(exclude_obj) {
    return _c('option', {
      domProps: {
        "value": exclude_obj.eId
      }
    }, [_vm._v(_vm._s(exclude_obj.excludeName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.exclude')),
      expression: "errors.has('form-1.exclude')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Exclude")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Include")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Include),
      expression: "Include"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Include')
    },
    attrs: {
      "name": "Include",
      "id": "Include"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.Include = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.IncludeList), function(include_obj) {
    return _c('option', {
      domProps: {
        "value": include_obj.IncludeId
      }
    }, [_vm._v(_vm._s(include_obj.IncludeName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.Include')),
      expression: "errors.has('form-1.Include')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Include")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select Hub")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('HubName')
    },
    attrs: {
      "name": "hubname",
      "id": "hubname"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.hubServiceCenterList), function(hub_obj) {
    return _c('option', {
      domProps: {
        "value": hub_obj.HubID
      }
    }, [_vm._v(_vm._s(hub_obj.HubName))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.hubname')),
      expression: "errors.has('form-1.hubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Hub")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Select  Date")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('toDate')
    },
    attrs: {
      "id": "toDate",
      "type": "Date",
      "name": "toDate",
      "placeholder": "Enter To Date"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.toDate')),
      expression: "errors.has('form-1.toDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select To Date")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Generate New Batch ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar",
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    on: {
      "click": _vm.clear
    }
  }), _vm._v(" Reset Batch")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('p', {
    staticClass: "text-show-batches",
    on: {
      "click": function($event) {
        return _vm.showBatch()
      }
    }
  }, [_vm._v("Show Batches")])])], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scanShipmentBatchFlag == true),
      expression: "scanShipmentBatchFlag == true"
    }],
    staticClass: "card-headerfrm ScanTally"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Shipment ID ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingId),
      expression: "shippingId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shippingId')
    },
    attrs: {
      "type": "text",
      "name": "",
      "id": "shippingId"
    },
    domProps: {
      "value": (_vm.shippingId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.shippingId')),
      expression: "errors.has('form-1.shippingId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Enter shippingId")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Comments")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comments),
      expression: "comments"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('comments')
    },
    attrs: {
      "name": "comments",
      "id": "comments"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comments = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.commentsObjList), function(comment_obj) {
    return _c('option', {
      domProps: {
        "value": comment_obj.comments
      }
    }, [_vm._v(_vm._s(comment_obj.comments))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('form-1.comments')),
      expression: "errors.has('form-1.comments')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" Please Select comments ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("Scan ")])])], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBatchesFlag == true),
      expression: "showBatchesFlag == true"
    }],
    staticClass: "card-headerfrm ScanTally"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    attrs: {
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("401B7YHFKC")]), _vm._v(" "), _c('td', [_vm._v("ProcessDone")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.scanShipments()
      }
    }
  }, [_vm._v("Scan Shipments")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('totalshipments')
      }
    }
  }, [_vm._v("1628")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('totalScan')
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('pendingScan')
      }
    }
  }, [_vm._v("1478")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('ofd')
      }
    }
  }, [_vm._v("119")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('totalAverage')
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('ntsAverage')
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.shipmentScanTally('RecShipment')
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("04-07-2019 18:23:41\t")]), _vm._v(" "), _c('td', [_vm._v("Batch Closed Date")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.scanShipments()
      }
    }
  }, [_vm._v("Tally Batch ")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.scanShipments()
      }
    }
  }, [_vm._v("Update Batch ")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.scanShipments()
      }
    }
  }, [_vm._v("Close Batch \t")]), _vm._v(" "), _c('td', {
    staticClass: "linkcolor",
    on: {
      "click": function($event) {
        return _vm.scanShipments()
      }
    }
  }, [_vm._v("Download ")])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shipmentDetailsFlag == true),
      expression: "shipmentDetailsFlag == true"
    }],
    staticClass: "card-headerfrm ScanTally"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row shipmentDetails"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "linkcolor"
  }, [_vm._v(" Total Shipments ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            ( " + _vm._s(this.shipmentStatusType) + " ) :\n          ")]), _vm._v(" "), _c('label', {
    staticClass: "linkcolor"
  }, [_vm._v(" 119 ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "linkcolor export-data",
    on: {
      "click": _vm.exportShipmentData
    }
  }, [_vm._v(" Export ")])])])]), _vm._v(" "), _vm._m(5)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('p', [_vm._v(" Audit Shipment Tally ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" Batch No ")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(" 401B7YHFKC")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row shipmentDetails"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "linkcolor scan-shipment"
  }, [_vm._v("Please click ‘Scan Shipments’ from action")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', {
    staticStyle: {
      "color": "#c4519c",
      "font-weight": "bold"
    }
  }, [_vm._v(" Batch List  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "linkcolor"
  }, [_vm._v("Total Batches : 1   ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "linkcolor export-data"
  }, [_vm._v("Reload Batches ")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead"
  }, [_c('th', [_vm._v("BatchID")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Total Shipments")]), _vm._v(" "), _c('th', [_vm._v("Total Scan")]), _vm._v(" "), _c('th', [_vm._v("Pending ScanTally")]), _vm._v(" "), _c('th', [_vm._v("Is OFD Shipments")]), _vm._v(" "), _c('th', [_vm._v("Total Overage")]), _vm._v(" "), _c('th', [_vm._v("Total NTS Overage")]), _vm._v(" "), _c('th', [_vm._v("Total REC Shipments")]), _vm._v(" "), _c('th', [_vm._v("Batch Generated Date\t")]), _vm._v(" "), _c('th', [_vm._v("Batch Closed Date")]), _vm._v(" "), _c('th', [_vm._v("Tally Batch")]), _vm._v(" "), _c('th', [_vm._v("Update Batch")]), _vm._v(" "), _c('th', [_vm._v("Close Batch\t")]), _vm._v(" "), _c('th', [_vm._v("Export Total Shipment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('h6', [_vm._v(" Shipment Details ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "batches table-bordered table-hover tbl datatables",
    attrs: {
      "cellpadding": "10",
      "cellspacing": "10"
    }
  }, [_c('thead', {
    staticClass: "thead"
  }, [_c('th', [_vm._v("BatchID")]), _vm._v(" "), _c('th', [_vm._v("ShippingID")]), _vm._v(" "), _c('th', [_vm._v("ScanTally InScan Date\t")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("ShipmentStatus")]), _vm._v(" "), _c('th', [_vm._v("CurrentHubName")]), _vm._v(" "), _c('th', [_vm._v("NotificationType")]), _vm._v(" "), _c('th', [_vm._v("OctroiMRP")]), _vm._v(" "), _c('th', [_vm._v("NetPayment")]), _vm._v(" "), _c('th', [_vm._v("ShippingDate")]), _vm._v(" "), _c('th', [_vm._v("LastProcessDate")]), _vm._v(" "), _c('th', [_vm._v("OrderType\t")]), _vm._v(" "), _c('th', [_vm._v("GapDays")]), _vm._v(" "), _c('th', [_vm._v("Comments")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("401B7YHFKC")]), _vm._v(" "), _c('td', [_vm._v("1111122267")]), _vm._v(" "), _c('td', [_vm._v("05/07/2019")]), _vm._v(" "), _c('td', [_vm._v("Shipped")]), _vm._v(" "), _c('td', [_vm._v("InScan")]), _vm._v(" "), _c('td', [_vm._v("PNQ/DPR (401)")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("151.00")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("401B7YHFKC")]), _vm._v(" "), _c('td', [_vm._v("1111122267")]), _vm._v(" "), _c('td', [_vm._v("05/07/2019")]), _vm._v(" "), _c('td', [_vm._v("Shipped")]), _vm._v(" "), _c('td', [_vm._v("InScan")]), _vm._v(" "), _c('td', [_vm._v("PNQ/DPR (401)")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("151.00")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3d85e8","hasScoped":true}!./src/views/components/ScanTally/shipmentScanTallyAuditNew/shipmentScanTallyAuditNew.component.html
// module id = 1126
// module chunks = 1